import { useEffect, useState } from "react";
import CustomerDisplay from "@rista/ui/components/CustomerDisplay";
import { CustomerCartPayload } from "@rista/core/customerDisplay";
import { onCustomerCart, requestCustomerCart, sendToPos } from "utils/customerDisplay";

/**
 * Desktop wiring for the customer display. The UI itself is shared with mobile
 * (@rista/ui) — this file is only the transport glue, which mobile does not need
 * because it reads the sale straight off its own store.
 *
 * Mounted directly by index.tsx, NOT through Routes: this window has no redux
 * store, no router and no auth token. Everything it renders arrives in the
 * pushed payload, which is what keeps it correct regardless of what the POS
 * window is doing.
 */
const CustomerDisplayScreen = () => {
  const [payload, setPayload] = useState<CustomerCartPayload>({});

  useEffect(() => {
    const off = onCustomerCart((data: CustomerCartPayload) => setPayload(data || {}));
    // The shell caches the last cart; this asks for a replay so a display that
    // mounted (or reloaded) mid-order is not blank until the next cart edit.
    requestCustomerCart();
    return off;
  }, []);

  return <CustomerDisplay
    sale={payload.sale}
    currency={payload.currency}
    decimals={payload.decimals}
    grouping={payload.grouping}
    campaignConfig={payload.campaignConfig}
    staticMediaBaseUrl={payload.staticMediaBaseUrl}
    logoUrl={payload.logoUrl}
    itemDisplayInfo={payload.itemDisplayInfo}
    paymentDetails={payload.paymentDetails}
    isPaymentInProcess={payload.isPaymentInProcess}
    canCustomerEnterNumber={payload.canCustomerEnterNumber}
    saleClosedAt={payload.saleClosedAt}
    fetchCustomerNumber={(number: string) =>
      sendToPos({ type: "customerNumber", number })
    } />;
};

export default CustomerDisplayScreen;
